import React from "react";
import NewCarousel from "./NewCarousel";
import CategorySection from "./CategorySection";
import HomePageCards from "./HomePageCards";

const HeroSection = () => {
  return (
    <>
      <div className="flex flex-col-reverse md:flex-col lg:flex-row lg:mt-8 rounded-md max-w-[1241px] px-[16px] lg:h-[509px] gap-y-[24px] md:gap-y-[16px] lg:gap-y-0 lg:gap-x-[11px] lg:bg-white justify-center items-center m-auto z-0 relative md:bg-transparent md:border-0 lg:border md:px-[24px] lg:px-0 mt-[16px] md:mt-0">
        <CategorySection />

        <div className="md:order-1">
          <NewCarousel />
        </div>

        <div className="hidden md:flex lg:flex-col gap-y-[9px] lg:h-[476px] lg:justify-between md:order-2">
          <HomePageCards />
        </div>
      </div>

      {/* <div className="flex flex-col-reverse md:flex-col lg:flex-row lg:mt-8 rounded-md max-w-[1241px] px-[16px] lg:h-[509px] gap-y-[24px] md:gap-y-[16px] lg:gap-y-0 lg:gap-x-[11px] lg:bg-white justify-center items-center m-auto z-0 relative md:bg-transparent md:border-0 lg:border md:px-[24px] lg:px-0 mt-[16px] md:mt-0">
        <div className="order-1 lg:order-3">
          <NewCarousel />
        </div>

        <div className="hidden md:flex lg:flex-col gap-y-[9px] lg:h-[476px] lg:justify-between md:order-1 lg:order-3">
          <HomePageCards />
        </div>

        <div className="md:order-2 lg:order-1 order-2">
          <CategorySection />
        </div>
      </div> */}
    </>
  );
};

export default HeroSection;
